import { useState } from 'react';
import { Outlet } from 'react-router-dom';
// @mui
import { styled } from '@mui/material/styles';
//
import Header from './header';
import Nav from './nav';
import { Box, Typography } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";


const APP_BAR_MOBILE = 64;
const APP_BAR_DESKTOP = 92;

const StyledRoot = styled('div')({
  display: 'flex',
  minHeight: '100%',
  overflow: 'hidden',
});

const Main = styled('div')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: APP_BAR_MOBILE + 24,
  // paddingBottom: theme.spacing(1),
  [theme.breakpoints.up('lg')]: {
    paddingTop: APP_BAR_DESKTOP + 24,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
  },
}));

// ----------------------------------------------------------------------

export default function DashboardLayout() {
  const [open, setOpen] = useState(false);
  const theme = useTheme();
  const isBelow768 = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <StyledRoot>
      <Header onOpenNav={() => setOpen(true)} />

      <Nav openNav={open} onCloseNav={() => setOpen(false)} />

      <Main>
        <Outlet />
        <Box
          sx={{
            padding: "3px 0",
            position:'fixed',
            right:5,
            bottom:0,
            display: "flex",
            justifyContent: isBelow768 ? "center" : "flex-end",
            alignItems: "center",
            width: "100%",
            backgroundColor:'white'
          }}
        >
    
            <a
              style={{ textDecoration: "none" }}
              href="https://meon.co.in/"
              rel="noreferrer"
              target="_blank"
            >
              {" "}
              <img src="/meon.png" width={95} alt="im" />
            </a>{" "}
        
        </Box>
      </Main>
    </StyledRoot>
  );
}
